<template>
  <figure
    v-if="isFinished"
    class="relative isolate mb-4 rounded-b-lg bg-surface-base">
    <div
      v-if="locked"
      class="absolute inset-0 z-10 grid place-items-center text-neutral">
      <UiIcon size="lg" name="lock" />
    </div>
    <img
      :alt="caption"
      :src="data || undefined"
      :class="{
        'brightness-50': locked,
      }"
      class="mx-auto aspect-3/2 object-contain object-center" />
    <figcaption
      class="flex flex-col gap-2 rounded-b-lg border border-neutral-whisper bg-surface-level-1 p-2">
      <div class="text-sm! font-semibold text-neutral-primary">
        {{ caption }}
      </div>
      <div class="text-xs! text-neutral-subtle!">© {{ creditline }}</div>
    </figcaption>
  </figure>
</template>

<script lang="ts" setup>
import UiIcon from "@dpa-id-components/dpa-shared-components/src/components/UiIcon/UiIcon.vue";
import { toRef } from "vue";

import { useImageAsset } from "@/composition/api/useImageAsset.ts";

const { urn, parenturn = null } = defineProps<{
  parenturn?: string;
  urn: string;
  caption: string;
  creditline: string;
}>();

const imageUrn = toRef(() => urn);
const { data, isFinished, locked } = useImageAsset(imageUrn, () => parenturn, {
  immediate: true,
  onlyThumbnail: true,
});
</script>
